export default __webpack_public_path__ + "static/media/goals-render.510d2f5a.png";